export class MDDefenceFamilyBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public serviceName: string,
        public isApplicantFMMMLW: string,
        public isStampReadable: string,
        public isStampFromZSWB: string,
        public isSignaturePresent: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}